/**	Suche ob Stationen für das Spital existieren
 *
 */

let app = window.app || {};
app.data.wards = {};
app.getStationen = function (hospitals_id, callback) {
  if (!hospitals_id || Number.isNaN(hospitals_id) || hospitals_id == "NaN") {
    return;
  }
  if (app.data.wards[hospitals_id]) {
    // Falls Stationen bereits abgefragt wurden, keine erneute Anfrage starten
    callback(true);
    return true;
  }

  $.ajax({
    type: "GET",
    url: `${app.backend}/institutions/${hospitals_id}`,
    dataType: "json"
  })
    .done(function (data) {
      if (data.wards.length) {
        app.data.wards[hospitals_id] = data.wards.map((x) => {
          x.searchstring = `${x.label} ${x.searchterms} ${x.address.street}`;
          return x;
        });
        if (callback) {
          callback(true);
        }
        return;
      }
      if (callback) {
        callback(false);
      }
    })
    .fail(function (data, textStatus) {
      throw new Error(textStatus + "; " + data.responseText);
    });
};

/**	Typeahead auf Stationen-Feld aktivieren
 *
 */
app.aktiviereTypeahead = function (hospitals_id, abschnitt) {
  if (hospitals_id === undefined) {
    hospitals_id = $(`#i${abschnitt}-bezeichnung-id`).val();
  }
  if (!hospitals_id) {
    // "Altes" typeahead auf Stationsauswahl zerstören
    $(`#i${abschnitt}-station.autocomplete-ward`).typeahead("destroy");
    // app.aktiviereTypeahead abbrechen
    return true;
  }
  app.getStationen(hospitals_id, function (erfolg) {
    // "Altes" typeahead auf Stationsauswahl zerstören
    $(`#i${abschnitt}-station.autocomplete-ward`).typeahead("destroy");

    // Falls keine Stationen gefunden breche app.getStationen ab
    if (erfolg === false) {
      return true;
    }

    /**	Stationen laden
     *
     */
    let stationenBloodhound = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace("searchstring"),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      local: app.data.wards[hospitals_id],
      identify: function (obj) {
        return obj.label;
      }
    });

    // initialize the bloodhound suggestion engine
    stationenBloodhound.initialize();

    function stationenDefaults(q, sync) {
      if (q === "") {
        sync(Object.values(stationenBloodhound.index.datums));
      } else {
        stationenBloodhound.search(q, sync);
      }
    }

    // typeahead aktivieren
    $(`#i${abschnitt}-station.autocomplete-ward`).typeahead(
      {
        // hint: true,
        minLength: 0,
        highlight: true
      },
      {
        name: "stationen",
        source: stationenDefaults,
        displayKey: "label",
        templates: {
          suggestion: function (data) {
            return $("<div>").text(data.label);
          }
        }
      }
    );
  });
};
// Ende Typeahead auf Stationen-Feld aktivieren

app.aktiviereBloodhound = function () {
  /**	Autocomplete-Funktion von Twitter. Besteht aus zwei Teilen:
   * 			Bloodhound ist der «Datenmanager»
   * 			typeahead.js ist das Anzeigeprogramm
   */

  /** 	Bloodhound ist die Funktion, welche die Antwort auf die Anfrage
   * 		von typeahead organisiert, woher auch immer die Daten kommen
   */

  /**	Objekt für Server-Suche
   *
   */
  let institutionsSource = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.whitespace,
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      url: `${app.backend}/institutions/scored/?searchterms={query}`,
      wildcard: "{query}",
      filter: function (searchServer) {
        return searchServer.map((x) => {
          return {
            label: x[0].label,
            address: x[0].address.street,
            zip: x[0].address.zip,
            city: x[0].address.location,
            country: x[0].address.country,
            lat: x[0].address.lat,
            long: x[0].address.long,
            hospitals_id: x[0].uuid
          };
        });
      }
    }
  });

  /**	Objekt für GraphHopper-Suche
   *
   */
  let graphHopperSource = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.whitespace,
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      // limit höher, weil anschliessend noch filter kommt
      // provider= um default zu nehmen
      url: `${app.backend}/gh/geocode?limit=25&q={query}&provider=`,
      wildcard: "{query}",
      filter: function (searchServer) {
        return searchServer.hits
          .filter((x) => {
            return x.postcode && x.city;
          })
          .sort((a, b) => {
            // Einträge Hospital oder mit Strasse höher gewichten
            // TODO: Ins backend verlagern
            if (a.osm_value == "hospital") return -1;
            return 0 + !a.street - (0 + !b.street);
          })
          .map((x) => {
            return {
              label: x.name,
              address: x.street,
              zip: x.postcode,
              city: x.city,
              country: x.country,
              lat: x.point.lat,
              long: x.point.lng
            };
          });
      }
    }
  });
  /**	Twitter typeahead.js erledigt das autocomplete auf dem Input-Feld
   * 		1. Quelle ist das Spitäler-Array vom Sanostat/von Alex
   * 		2. Quelle ist GraphHopper, für alles was nicht erfasst ist.
   */
  /* Funktionen festlegen */
  let typeaheadFunctions = {
    pending: function () {
      return $("<div>").addClass("tt-pending").text("Lade Ergebnisse…");
    },
    headerSearchServer: function () {
      return $("<div>")
        .addClass("tt-header")
        .html("Suche in Liste Rettung St.&#8239;Gallen");
    },
    headerGraphHopper: function () {
      return $("<div>").addClass("tt-header").text("Suche in OpenStreetMap");
    },
    suggestion: function (data) {
      if (data.label) {
        return $("<div>").text(`${data.label}, ${data.address}, ${data.city}`);
      } else {
        return $("<div>")
          .addClass("tt-notFound")
          .text("Keine Ergebnisse für «" + data.query + "» gefunden.");
      }
    },
    notFound: function (data) {
      let header;
      if (data.dataset == 0 || data.dataset == 2 || data.dataset == 4) {
        header = typeaheadFunctions.headerSearchServer();
      } else {
        header = typeaheadFunctions.headerGraphHopper();
      }
      let notFoundHtml = [
        header,
        $("<div>")
          .addClass("tt-notFound")
          .text("Keine Ergebnisse für «" + data.query + "» gefunden.")
      ];

      return notFoundHtml;
    },
    display: function (data) {
      return data.label;
    }
  };

  /* Autocomplete auf Klasse legen */
  $(".autocomplete-address").typeahead(
    {
      minLength: 2,
      highlight: true
    },
    {
      display: typeaheadFunctions.display,
      source: institutionsSource,
      async: true,
      limit: "Infinity", // Limit wird in URL geregelt
      templates: {
        pending: typeaheadFunctions.pending,
        header: typeaheadFunctions.headerSearchServer,
        suggestion: typeaheadFunctions.suggestion, // TODO: Wird mit true statt query aufgerufen!
        notFound: typeaheadFunctions.notFound
      }
    },
    {
      display: typeaheadFunctions.display,
      source: graphHopperSource,
      async: true,
      limit: 9,
      templates: {
        header: typeaheadFunctions.headerGraphHopper,
        suggestion: typeaheadFunctions.suggestion,
        notFound: typeaheadFunctions.notFound
      }
    }
  );
};

$(document).ready(function () {
  // Ein Element wurde ausgewählt – Autocomplete Spitalfeld
  $(".autocomplete-address").on("typeahead:select", function (event, element) {
    let id = $(this).prop("id");
    let hospitals_id = element.hospitals_id;
    let abschnitt = String(id).substring(1, String(id).indexOf("-"));
    $(`#i${abschnitt}-bezeichnung`).trigger("change");
    $(`#i${abschnitt}-bezeichnung-id`).val(hospitals_id).trigger("change");
    $(`#i${abschnitt}-strasse`)
      .val(element.address)
      .trigger("change")
      .parent()
      .velocity("callout.bounce", 500);
    $(`#i${abschnitt}-plz`)
      .val(element.zip)
      .trigger("change")
      .parent()
      .velocity("callout.bounce", 500);
    $(`#i${abschnitt}-ort`)
      .val(element.city)
      .trigger("change")
      .parent()
      .velocity("callout.bounce", 500);
    $(`#i${abschnitt}-land`).val(element.country).trigger("change");
    $(`#i${abschnitt}-lat`).val(element.lat).trigger("change");
    $(`#i${abschnitt}-lng`).val(element.long).trigger("change");

    app.aktiviereTypeahead(hospitals_id, abschnitt);
  });
  $(".autocomplete-address").on("typeahead:close", function () {
    // Wäre eigentlich nicht mehr nötig, aber zur Sicherheit noch einmal
    let id = $(this).prop("id");
    let abschnitt = String(id).substring(1, String(id).indexOf("-"));
    app.aktiviereTypeahead(undefined, abschnitt);
  });

  // Ein Element wurde ausgewählt – Autocomplete Stationsfeld
  $(".autocomplete-ward").on("typeahead:select", function (event, element) {
    let id = $(this).prop("id");
    let abschnitt = String(id).substring(1, String(id).indexOf("-"));

    $(`#i${abschnitt}-station`).trigger("change");
    $(`#i${abschnitt}-station-id`).val(element.uuid).trigger("change");
    $(`#i${abschnitt}-strasse`)
      .val(element.address.street)
      .trigger("change")
      .parent()
      .velocity("callout.bounce", 500);
    $(`#i${abschnitt}-plz`)
      .val(element.address.zip)
      .trigger("change")
      .parent()
      .velocity("callout.bounce", 500);
    $(`#i${abschnitt}-ort`)
      .val(element.address.location)
      .trigger("change")
      .parent()
      .velocity("callout.bounce", 500);
    $(`#i${abschnitt}-land`).val(element.address.country).trigger("change");
    $(`#i${abschnitt}-haus`)
      .val(element.address.house)
      .trigger("change")
      .parent()
      .velocity("callout.bounce", 500);
    $(`#i${abschnitt}-stock`)
      .val(element.address.floor)
      .trigger("change")
      .parent()
      .velocity("callout.bounce", 500);
    $(`#i${abschnitt}-lat`).val(element.address.lat).trigger("change");
    $(`#i${abschnitt}-lng`).val(element.address.long).trigger("change");
  });

  // Bugfix: Sonst wird teilw. wenn keine Eingabe erfolgte Feld geleert
  $(".autocomplete-address, .autocomplete-ward").on(
    "typeahead:open",
    function () {
      $(this).typeahead("val", $(this).val());
    }
  );

  // Ende autocomplete-address
});
